import type { DataViewBreakpoint, DataViewColumn } from './DataView.js'

export const BP_MIN_PX: Record<DataViewBreakpoint, number> = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200,
  xl: 1400,
}

export function cellVal(row: Record<string, unknown>, col: DataViewColumn): string {
  const v = col.render ? col.render(row) : row[col.key]
  return String(v ?? '')
}

export function gtScopeId(columns: DataViewColumn[]): string {
  let h = 0
  for (const c of columns) {
    const s = c.key + (c.span ? JSON.stringify(c.span) : '')
    for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) & 0xffffff
  }
  return h.toString(36)
}

export function gtSpanStyles(columns: DataViewColumn[], scopeId: string): string {
  const lines: string[] = []
  for (const col of columns) {
    if (!col.span || typeof col.span !== 'object') continue
    const { base, ...bpSpans } = col.span as Partial<Record<DataViewBreakpoint | 'base', number>>
    const sel = `.dv-gt-scope-${scopeId} .dv-gt-cell-${scopeId}-${col.key}`
    if (base !== undefined) lines.push(`${sel}{flex:${base} 1 0;min-width:0}`)
    for (const [bp, val] of Object.entries(bpSpans) as [DataViewBreakpoint, number | undefined][]) {
      if (val === undefined || !(bp in BP_MIN_PX)) continue
      lines.push(`@media(min-width:${BP_MIN_PX[bp]}px){${sel}{flex:${val} 1 0}}`)
    }
  }
  return lines.join('')
}

export function gtCellFlex(col: DataViewColumn): string | undefined {
  if (col.width) {
    const w = typeof col.width === 'number' ? `${col.width}px` : col.width
    return `flex: 0 0 ${w}; min-width: 0`
  }
  if (typeof col.span === 'number') return `flex: ${col.span} 1 0; min-width: 0`
  return undefined
}
